<template>
  <div class="list dcb-steps">
    <AccordionItem
      v-for="(entry, key) in isGoogle ? listGoogle : listApple"
      :key="key"
      ref="itemRefs"
      class="dcb-steps__accordion"
      :is-open="key === 0"
      @update:isOpen="open($event, key)"
    >
      <template #title>{{ key + 1 }}. {{ entry.title }}</template>
      <template #content>
        {{ entry.content }}

        <QrCodeAppStore v-if="key === 0 && !isGoogle" />
        <QrCodeGooglePlay v-else-if="key === 0 && isGoogle" />
      </template>
    </AccordionItem>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import QrCodeAppStore from '@/components/dcb/qr-code-app-store.vue';
import QrCodeGooglePlay from '@/components/dcb/qr-code-google-play.vue';
import { AccordionItem } from '@i22-td-smarthome/component-library';

const props = defineProps({
  isGoogle: { type: Boolean },
});

const itemRefs = ref([]);
const emit = defineEmits<{
  (e: 'teaser-step', src: string): void;
}>();

const listGoogle = [
  {
    title: 'QR Code scannen',
    content:
      'QR-Code scannen oder Link klicken, um zu den Einstellungen Deines Smartphones zu gelangen.',
    image: {
      src: '/content/content-images/dcb/a9a388d6b9c19e60a7c26ac275c445ef/dcb-teaser-qr.svg',
      alt: 'Eine Frau steht vor einem großen QR-Code und hält ein Handy in der Hand.',
    },
  },
  {
    title: 'Zahlungsmethode wählen',
    content: 'Die Zahlungsmethode „Telekom - Zahl einfach per Handyrechnung“ auswählen.',
    image: {
      src: '/content/content-images/dcb/da3a331b386d9ba21bd0f98b4311b8d2/keyvisual-android-step-3.png',
      alt: 'Eine Frau steht vor einem Bildschirm, der Zahlungsmethoden anzeigt.',
    },
  },
];

const listApple = [
  {
    title: 'QR Code scannen',
    content:
      'QR-Code scannen oder Link klicken, um zu den Einstellungen Deines Smartphones zu gelangen.',
    image: {
      src: '/content/content-images/dcb/a9a388d6b9c19e60a7c26ac275c445ef/dcb-teaser-qr.svg',
      alt: 'Eine Frau steht vor einem großen QR-Code und hält ein Handy in der Hand.',
    },
  },
  {
    title: 'Zahlungsmethode hinzufügen',
    content: 'Auf „Zahlungsmethode hinzufügen“ klicken.',
    image: {
      src: '/content/content-images/dcb/493142ddb6945d15e998ce3e9e756183/keyvisual-iOS-step-2.png',
      alt: 'Eine Frau steht mit einem Handy in der Hand vor Einkaufstaschen. Auf einem Bildschirm ist die Option, eine Zahlungsmethode hinzuzufügen, zu sehen, daneben ein Pluszeichen.',
    },
  },
  {
    title: 'Zahlungsmethode wählen',
    content: 'Die Zahlungsmethode „Handyrechnung“ auswählen',
    image: {
      src: '/content/content-images/dcb/d1dd67940a66332338a1af82c1005c12/keyvisual-iOS-step-3.png',
      alt: 'Eine Frau steht vor einem Bildschirm, der Zahlungsmethoden anzeigt.',
    },
  },
];

// collapse other open elements
const open = (isOpen: boolean, currentIndex: number) => {
  if (!isOpen) return;
  itemRefs.value.forEach((el: any, index) => {
    // eslint-disable-next-line no-underscore-dangle
    if (currentIndex === index || !el?._data?.isOpenDerived) return;
    // eslint-disable-next-line no-param-reassign,no-underscore-dangle
    el._data.isOpenDerived = false;
  });
  emit(
    'teaser-step',
    props.isGoogle ? listGoogle[currentIndex]?.image || '' : listApple[currentIndex]?.image || ''
  );
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.dcb-steps {
  &__accordion {
    --theme-primary-color: transparent;
    --bg-color-hover: transparent;
    --bg-color-active: transparent;
    margin-bottom: $grid-base * 2;

    :deep(.accordion-item__title) {
      font-size: 1.2em;
    }

    :deep(.accordion-item__title--is-open) {
      color: var(--color-primary);
      font-weight: 800;
    }
  }
}
</style>
